<template>
  <div class="menu-related">
    <a
      target="_blank"
      v-for="other in content.links"
      :key="other.label"
      :href="other.url"
      >{{ other.label }}</a
    >
  </div>
</template>
<script>
export default {
  props: ["config", "content"]
};
</script>
<style lang="scss" scoped>
.menu-related {
  display: flex;
  flex-direction: column;
  .mobile &,
  .tablet & {
    @include ButtonM;
    text-decoration: none;
    color: $white;
    a {
      color: $white;
    }
  }
  .desktop & {
    @include ButtonS;
    text-decoration: none;
    color: $white-50;
    a {
      color: $white-50;
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>